import { ShieldCheck } from '@phosphor-icons/react';
import { Brand } from '../components/Brand';
import { ChangePasswordForm } from '../components/ChangePasswordForm';
import { Card } from '../components/Ui';

/**
 * The screen a temporary password lands on.
 *
 * Until this existed, `must_change_password` was written by the admin reset
 * path, returned by `/bootstrap`, and read by nobody — so the sign-in help and
 * the new-user form both promised a first-login change that never happened, and
 * a temporary password quietly became a permanent one.
 */
export function ChangePasswordPage({ onChanged, onSignOut }: { onChanged: () => void; onSignOut: () => void }) {
  return (
    <div className="full-state">
      <Brand />
      <Card>
        <div className="card-heading"><h2>رمز عبور خود را عوض کنید</h2></div>
        <div className="notice notice--info">
          <ShieldCheck size={20} weight="fill" />
          <div>
            رمزی که با آن وارد شدید موقت است و مدیر سامانه آن را می‌داند. برای ادامه، یک رمز
            تازه بگذارید که فقط خودتان از آن خبر دارید.
          </div>
        </div>
        <ChangePasswordForm onChanged={onChanged} />
        <button type="button" className="button button--ghost button--small" onClick={onSignOut}>
          خروج از حساب
        </button>
      </Card>
    </div>
  );
}
